import React from 'react';
import BurgerContact from "../../images/burger-contact.jpg";
import {FaAddressCard, FaEnvelope, FaPhoneAlt} from "react-icons/fa";

const Contact = () => {

    return (
        <div className="card-wrapper" style={{
            backgroundImage: `url(${BurgerContact})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundAttachment: "fixed"
        }}>
            <h2>Contact us</h2>

            <div className="bloc-form">
                <div className="form-wrapper">
                    <form>
                        <h3>Please fill the form</h3>
                        <label htmlFor="firstname">First Name</label>
                        <input type="text" id="firstname" name="firstname" placeholder="Your name..." />

                        <label htmlFor="lastname">Last Name</label>
                        <input type="text" id="lastname" name="lastname" placeholder="Your last name..." />

                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" name="email" placeholder="Your email..." />

                        <label htmlFor="country">Country</label>
                        <select id="country" name="country">
                            <option value="australia">France</option>
                            <option value="canada">Germany</option>
                            <option value="usa">Italy</option>
                        </select>

                        <input className="button-package" type="submit" value="Submit" />
                    </form>
                </div>
                <div className="info-wrapper">
                    <h3>Infos</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet aperiam assumenda, delectus doloremque ducimus excepturi expedita fuga hic id ipsam magni odio, perferendis praesentium quaerat quos repellendus reprehenderit saepe, sunt.</p>
                    <hr className="style-hr"/>
                    <p><FaAddressCard /> Address: 71 Cherry Court SOUTHAMPTON SO53 5PD UK</p>
                    <p><FaEnvelope /> Email: example.example.com</p>
                    <p><FaPhoneAlt /> Phone: +44 7911 123456</p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
